<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header main-card-header">
        <span>TravelPass</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body main-card-body">
        <b-row>
          <b-col md="12">
            <div class="d-flex">
              <div class="qr-scanner text-center" v-if="mData.viewMode == 'detail'">
                <div class="mb-3 camera-qr">
                  <QrcodeStream :camera="mData.dataDefault.camera" @decode="onDecode" v-if="mData.dataDefault.camera == 'auto'"/>
                  <div  v-if="mData.dataDefault.camera == 'off'">
                    <a style="font-size: 180px; cursor: pointer;" @click="openCamera()"><i class="fa fa-qrcode" aria-hidden="true"></i></a>
                  </div>
                </div>
                <el-input v-model.trim="mData.dataDefault.qr" placeholder="Nhập mã TP để tìm kiếm"></el-input>
                <el-button class="mt-3" type="primary" v-ladda @click="find()"
                  >Tìm kiếm</el-button
                >
              </div>
              <div class="ml-4">
                <el-form label-position="top">
                  <div class="row">
                    <!-- <div class="col-lg-3 col-sm-4 col-6">
                      <el-form-item label="Loại">
                        <el-input
                          v-model="mData.dataDefault.dataPassport.ho_chieu.loai"
                          disabled
                        ></el-input>
                      </el-form-item>
                    </div> -->
                    <div class="col-lg-6 col-sm-4 col-6">
                      <el-form-item label="Mã số">
                        <el-input
                          v-model="
                            mData.dataDefault.dataPassport.ho_chieu.ma_so
                          "
                          disabled
                        ></el-input>
                      </el-form-item>
                    </div>
                    <div class="col-lg-6 col-sm-4 col-12">
                      <el-form-item label="Số hộ chiếu">
                        <el-input
                          v-model="
                            mData.dataDefault.dataPassport.ho_chieu.so_ho_chieu
                          "
                          disabled
                        ></el-input>
                      </el-form-item>
                    </div>
                    <div class="col-12">
                      <el-form-item label="Họ và tên">
                        <el-input
                          v-model="
                            mData.dataDefault.dataPassport.ho_chieu.ho_ten
                          "
                          disabled
                        ></el-input>
                      </el-form-item>
                    </div>
                    <div class="col-md-6 col-12">
                      <el-form-item label="Quốc tịch">
                        <el-select
                          v-model="
                            mData.dataDefault.dataPassport.ho_chieu.quoc_tich_id
                          "
                          placeholder="Chọn"
                          disabled
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listQuocGia"
                            :key="item.id"
                            :label="
                              item.ten_quoc_tich && item.ten_quoc_tich.vi
                                ? item.ten_quoc_tich.vi
                                : ''
                            "
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="col-md-6 col-12">
                      <el-form-item label="Ngày sinh">
                        <el-date-picker
                          v-model="
                            mData.dataDefault.dataPassport.ho_chieu.ngay_sinh
                          "
                          type="date"
                          disabled
                          :format="aElement.datepicker.formatDate"
                          :valueFormat="aElement.datepicker.valueFormat"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </div>
                    <!-- <div class="col-12">
                      <el-form-item label="Nơi sinh">
                        <el-input
                          v-model="
                            mData.dataDefault.dataPassport.ho_chieu.noi_sinh
                          "
                          disabled
                        ></el-input>
                      </el-form-item>
                    </div> -->
                    <div class="col-md-6 col-12">
                      <el-form-item label="Giới tính">
                        <el-radio
                          v-model="
                            mData.dataDefault.dataPassport.ho_chieu.gioi_tinh
                          "
                          :label="1"
                          disabled
                          class="mr-2"
                          >Nam</el-radio
                        >
                        <el-radio
                          v-model="
                            mData.dataDefault.dataPassport.ho_chieu.gioi_tinh
                          "
                          :label="2"
                          disabled
                          class="mr-2"
                          >Nữ</el-radio
                        >
                        <el-radio
                          v-model="
                            mData.dataDefault.dataPassport.ho_chieu.gioi_tinh
                          "
                          :label="4"
                          disabled
                          class="mr-2"
                          >Khác</el-radio
                        >
                      </el-form-item>
                    </div>
                    <!-- <div class="col-md-6 col-12">
                      <el-form-item label="Số GCMND">
                        <el-input
                          v-model="mData.dataDefault.dataPassport.ho_chieu.cmnd"
                          disabled
                        ></el-input>
                      </el-form-item>
                    </div>
                    <div class="col-md-6 col-12">
                      <el-form-item label="Ngày cấp">
                        <el-date-picker
                          v-model="
                            mData.dataDefault.dataPassport.ho_chieu.ngay_cap
                          "
                          type="date"
                          disabled
                          :format="aElement.datepicker.formatDate"
                          :valueFormat="aElement.datepicker.valueFormat"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </div> -->
                    <div class="col-md-6 col-12">
                      <el-form-item label="Có giá trị đến">
                        <el-date-picker
                          v-model="
                            mData.dataDefault.dataPassport.ho_chieu.hieu_luc_den
                          "
                          type="date"
                          disabled
                          :format="aElement.datepicker.formatDate"
                          :valueFormat="aElement.datepicker.valueFormat"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </div>
                    <!-- <div class="col-12">
                      <el-form-item label="Nơi cấp">
                        <el-input
                          v-model="
                            mData.dataDefault.dataPassport.ho_chieu.noi_cap
                          "
                          disabled
                        ></el-input>
                      </el-form-item>
                    </div> -->
                    <div class="col-12">
                      <el-form-item label="Ảnh hộ chiếu" class="image-resize">
                        <div class="box-image">
                          <el-image
                            v-if="this.mData.dataDefault.anhPassport"
                            :src="this.mData.dataDefault.anhPassport"
                            lazy
                          ></el-image>
                        </div>
                      </el-form-item>
                    </div>
                    <div class="col-12">
                      <el-form-item label="Ảnh chân dung" class="image-resize">
                        <div class="box-image">
                          <el-image
                            v-if="this.mData.dataDefault.anhSelfie"
                            :src="this.mData.dataDefault.anhSelfie"
                            lazy
                          ></el-image>
                        </div>
                      </el-form-item>
                    </div>
                  </div>
                </el-form>
              </div>
            </div>
          </b-col>
        </b-row>
        <el-form
          :model="mData.dataForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-card>
            <div slot="header">
              Khai báo y tế
              <div class="card-header-actions">
                <b-link
                  class="card-header-action btn-minimize"
                  v-b-toggle.collapseYTe
                  v-b-tooltip.hover
                  :title="'ẩn/hiện'"
                >
                  <i class="icon-arrow-up"></i>
                </b-link>
              </div>
            </div>
            <b-collapse id="collapseYTe" visible>
              <b-row>
                <b-col md="12">
                  <el-form-item
                    label="Trong vòng 14 ngày qua, Anh/Chị có đến quốc gia/vùng lãnh thổ nào (có thể đi qua nhiều quốc gia)"
                    prop="y_te.danh_sach_quoc_gia_da_den"
                  >
                    <el-select
                      v-model="mData.dataForm.y_te.danh_sach_quoc_gia_da_den"
                      placeholder="Chọn"
                      multiple
                      filterable
                      disabled
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listQuocGia"
                        :key="item.id"
                        :value="item.id"
                        :label="
                          item.ten_quoc_gia && item.ten_quoc_gia.vi
                            ? item.ten_quoc_gia.vi
                            : ''
                        "
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col md="12">
                  <el-form-item
                    label="Trong vòng 14 ngày qua Anh/Chị có thấy xuất hiện dấu hiệu nào sau đây không?"
                    prop="y_te.danh_sach_dau_hieu"
                  >
                    <el-select
                      v-model="mData.dataForm.y_te.danh_sach_dau_hieu"
                      placeholder="Chọn"
                      multiple
                      filterable
                      disabled
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listDauHieu"
                        :key="item.value"
                        :value="item.value"
                        :label="item.name"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col md="12">
                  <el-form-item
                    label="Trong vòng 14 ngày qua Anh/Chị có tiếp xúc với"
                    prop="y_te.danh_sach_tiep_xuc"
                  >
                    <el-select
                      v-model="mData.dataForm.y_te.danh_sach_tiep_xuc"
                      placeholder="Chọn"
                      multiple
                      filterable
                      disabled
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listKBYTTiepXuc"
                        :key="item.id"
                        :value="item.id"
                        :label="item.ten && item.ten.vi ? item.ten.vi : ''"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col md="12">
                  <el-form-item
                    label="Hiện tại Anh/Chị có các bệnh nào dưới đây"
                    prop="y_te.danh_sach_benh"
                  >
                    <el-select
                      v-model="mData.dataForm.y_te.danh_sach_benh"
                      placeholder="Chọn"
                      multiple
                      filterable
                      disabled
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listKBYTBenh"
                        :key="item.id"
                        :value="item.id"
                        :label="item.ten && item.ten.vi ? item.ten.vi : ''"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col md="12">
                  <el-form-item label="Thân nhiệt" prop="y_te.than_nhiet">
                    <el-input-number
                      v-model="mData.dataForm.y_te.than_nhiet"
                      disabled
                    ></el-input-number>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
          <b-card>
            <div slot="header">
              VẮC XIN
              <div class="card-header-actions">
                <b-link
                  class="card-header-action btn-minimize"
                  v-b-toggle.collapseVaccine
                  v-b-tooltip.hover
                  :title="'ẩn/hiện'"
                >
                  <i class="icon-arrow-up"></i>
                </b-link>
              </div>
            </div>
            <b-collapse id="collapseVaccine" visible>
              <b-row>
                <b-col md="9">
                  <el-form-item label="Loại vắc xin" prop="tiem_chung.vaccine">
                    <el-select
                      v-model="mData.dataForm.tiem_chung.vaccine"
                      disabled
                      placeholder="Chọn"
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listVaccine"
                        :key="item.id"
                        :value="item.id"
                        :label="item.ten"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col md="3">
                  <el-form-item
                    label="Giá trị đến"
                    prop="tiem_chung.gia_tri_den"
                  >
                    <el-date-picker
                      v-model="mData.dataForm.tiem_chung.gia_tri_den"
                      type="date"
                      :format="aElement.datepicker.formatDate"
                      :valueFormat="aElement.datepicker.valueFormat"
                      disabled
                    >
                    </el-date-picker>
                  </el-form-item>
                </b-col>
                <b-col md="9">
                  <el-form-item
                    label="Số giấy chứng nhận"
                    prop="tiem_chung.so_giay_chung_nhan"
                  >
                    <el-input
                      v-model="mData.dataForm.tiem_chung.so_giay_chung_nhan"
                      disabled
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="3">
                  <el-form-item
                    label="Quốc gia"
                    prop="tiem_chung.quoc_gia_id"
                  >
                    <el-select
                      v-model="mData.dataForm.tiem_chung.quoc_gia_id"
                      placeholder="Chọn"
                      filterable
                      auto-complete="off"
                      disabled
                    >
                        <el-option
                          v-for="item in mData.dataDefault.listQuocGia"
                          :key="item.id"
                          :value="item.id"
                          :label="
                          item.ten_quoc_gia && item.ten_quoc_gia.en
                              ? item.ten_quoc_gia.en
                              : ''
                          "
                        >
                        </el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row
                v-for="(luot_tiem, index) in mData.dataForm.tiem_chung
                  .luot_tiem"
                :key="index"
              >
                <b-col md="9">
                  <el-form-item
                    :label="'Nơi tiêm (' + renderTimes(index) + ')'"
                  >
                    <el-input
                      v-model="luot_tiem.dia_diem_tiem"
                      auto-complete="off"
                      disabled
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="3">
                  <el-form-item
                    :label="'Thời điểm tiêm (' + renderTimes(index) + ')'"
                  >
                    <el-date-picker
                      v-model="luot_tiem.thoi_gian_tiem"
                      type="date"
                      :format="aElement.datepicker.formatDate"
                      :valueFormat="aElement.datepicker.valueFormat"
                      auto-complete="off"
                      disabled
                    >
                    </el-date-picker>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <el-form-item label="Xác thực" prop="loai">
                    <el-radio
                      class="mr-2"
                      v-model="mData.dataForm.loai"
                      :label="1"
                      @change="changeRadioValue()"
                      disabled
                      >Ảnh</el-radio
                    >
                    <el-radio
                      class="mr-2"
                      v-model="mData.dataForm.loai"
                      :label="2"
                      @change="changeRadioValue()"
                      disabled
                      >Mã QR</el-radio
                    >
                    <!-- <el-radio
                      v-model="mData.dataForm.loai"
                      :label="3"
                      @change="changeRadioValue()"
                      disabled
                      >Đường dẫn</el-radio
                    > -->
                  </el-form-item>
                </b-col>
                <b-col md="12" v-show="mData.dataForm.loai == 1">
                  <el-form-item
                    label="Ảnh giấy chứng nhận"
                    prop="tiem_chung.anh_id"
                  >
                    <el-upload
                      action
                      :auto-upload="false"
                      drag
                      :limit="mData.fileUploadOption.Anh.limit"
                      :accept="mData.fileUploadOption.Anh.accept"
                      :on-change="fn_uploadChangeAnh"
                      :on-preview="fn_uploadPreviewAnh"
                      :on-remove="fn_uploadRemoveAnh"
                      :on-exceed="fn_uploadExceedAnh"
                      :file-list="mData.fileUploadOption.Anh.fileList"
                      :multiple="false"
                      :class="{ hide: mData.dataDefault.anh }"
                      disabled
                    >
                      <div v-if="!mData.dataDefault.anh">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                          Drop photo here or <em>click to upload</em>
                        </div>
                      </div>
                    </el-upload>
                    <b-row>
                      <b-col md="3" sm="6">
                        <div
                          style="max-width: 400px"
                          v-if="mData.dataDefault.anh"
                        >
                          <el-image :src="mData.dataDefault.anh" lazy></el-image>
                        </div>
                      </b-col>
                      <!-- <b-col md="3" sm="6" v-for="item in mData.dataDefault.anhVaccinationsUrl" :key="item.id">
                        <div
                          style="max-width: 400px"
                          v-if="mData.dataDefault.anhVaccinations"
                        >
                          <el-image :src="item.url" lazy></el-image>
                        </div>
                      </b-col> -->
                    </b-row>
                    <!-- <div
                      class="d-flex d-flex-re justify-content-center"
                      style="max-height: 400px"
                      v-if="mData.dataDefault.anh"
                    >
                      <el-image :src="mData.dataDefault.anh" lazy></el-image>
                    </div> -->
                  </el-form-item>
                </b-col>
                <!-- <b-col md="12" v-show="mData.dataForm.loai == 3">
                  <el-form-item label="Đường dẫn" prop="tiem_chung.link">
                    <el-input
                      v-model="mData.dataForm.tiem_chung.link"
                    ></el-input>
                    <a href="mData.dataForm.tiem_chung.link">{{
                      mData.dataForm.tiem_chung.link
                    }}</a>
                  </el-form-item>
                </b-col> -->
                <b-col md="6" v-show="mData.dataForm.loai == 2">
                  <el-form-item label="Mã QR" prop="tiem_chung.qr">
                    <div
                      class="mb-2"
                      style="width: 260px; height: 260px"
                    >
                      <QrCode :size="1000" error-level="L" class="qrs" :text="mData.dataForm.tiem_chung.qr"/>
                    </div>
                    <!-- <el-input
                      v-model="mData.dataForm.tiem_chung.qr"
                      disabled
                    ></el-input> -->
                  </el-form-item>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>

          <b-card>
            <div slot="header">
              XÉT NGHIỆM
              <div class="card-header-actions">
                <b-link
                  class="card-header-action btn-minimize"
                  v-b-toggle.collapseTest
                  v-b-tooltip.hover
                  :title="'ẩn/hiện'"
                >
                  <i class="icon-arrow-up"></i>
                </b-link>
              </div>
            </div>
            <b-collapse id="collapseTest" visible>
              <b-row class="mt-3">
                <b-col class="mb-3" xl="4" lg="6" md="6" v-for="(item,index) in mData.dataDefault.arrTestCertificate" :key="item.key">
                    <el-collapse v-model="activeNames">
                      <el-collapse-item :class="item.ket_qua_test == '260415000' ? 'not-detected' : 'detected'" :name="index">
                        <template slot="title">
                          {{item.ngay_xet_nghiem | dateFormat}} -
                          {{
                              item.ket_qua_test == "260415000" ? "Âm tính" :
                              item.ket_qua_test == "260373001" ? "Dương tính" : ""
                          }}
                          <p :class="(
                                        item.duoc_duyet == undefined || 
                                        item.duoc_duyet === null || 
                                        item.duoc_duyet === ''
                                    ) && item.anh_id && item.ten_quoc_gia !='Việt Nam' ? 'not-reviewed-yet' : 
                                    ( item.duoc_duyet === true ) && item.anh_id && item.ten_quoc_gia !='Việt Nam'? 'approved' : 
                                    ( item.duoc_duyet === false ) && item.anh_id && item.ten_quoc_gia !='Việt Nam'? 'refuse' : 'approved' ">
                            {{
                              (item.duoc_duyet === null || item.duoc_duyet === "") && item.anh_id && item.ten_quoc_gia !="Việt Nam" ? "(Chưa xét duyệt)" :
                              (item.duoc_duyet === true) && item.anh_id && item.ten_quoc_gia !="Việt Nam" ? "(Đã duyệt)" :
                              (item.duoc_duyet === false) && item.anh_id && item.ten_quoc_gia !="Việt Nam" ? "(Từ chối)" : "(Hợp lệ)"
                            }}
                          </p>
                        </template>
                        <b-row>
                          <b-col md="12">
                            <div
                              style="max-width: 250px; margin: 0 auto;"
                              v-if="item.anh_id && item.duoc_duyet !== true && item.ten_quoc_gia != 'Việt Nam'"
                            >
                              <el-image :src="imgUrl+item.anh_id" ></el-image>
                            </div>
                            <div
                              style="max-width: 250px; margin: 0 auto;"
                              v-if="!item.anh_id || item.duoc_duyet === true || item.ten_quoc_gia == 'Việt Nam'"
                            >
                              <QrCode error-level="L" class="qrs" :text="item.qr_code"/>
                            </div>
                          </b-col>
                          <b-col md="12">
                            <p> 
                              <span class="title-list">Xét nghiệm tại quốc gia: </span>
                              <span>{{item.ten_quoc_gia}}</span>
                            </p>
                            <p> 
                              <span class="title-list">Ngày xét nghiệm: </span>
                              <span>{{item.ngay_xet_nghiem | dateFormat}}</span>
                            </p>
                            <p> 
                              <span class="title-list">Kết quả xét nghiệm: </span>
                              <span>
                                {{
                                  item.ket_qua_test == "260415000" ? "Âm tính" :
                                  item.ket_qua_test == "260373001" ? "Dương tính" : ""
                                }}
                              </span>
                            </p>
                            <p> 
                              <span class="title-list">Loại xét nghiệm: </span> 
                              <span>
                                {{
                                  item.loai_xet_nghiem == "LP6464-4" ? "Xét nghiệm PCR/NAAT" :
                                  item.loai_xet_nghiem == "LP217198-3" ? "Xét nghiệm nhanh" : ""
                                }}
                              </span>
                            </p>
                            <p v-if='item.loai_xet_nghiem == "LP217198-3"'> 
                              <span class="title-list">Tên xét nghiệm: </span>
                              <span>{{item.ten_xet_nghiem}}</span>
                            </p>
                            <p v-if='item.loai_xet_nghiem == "LP6464-4"'> 
                              <span class="title-list">Trung tâm/Cơ sở xét nghiệm: </span>
                              <span>{{item.noi_xet_nghiem}}</span>
                            </p>
                          </b-col>
                          <b-col class="mt-3" md="12">
                            <el-form-item class="text-center" v-if="item.duoc_duyet === '' && item.anh_id && item.ten_quoc_gia !='Việt Nam'">
                              <el-button
                                type="danger"
                                @click="showModalTestCertificate('refuse',item.key)"
                                >Từ chối</el-button
                              >
                              <el-button
                                type="primary"
                                @click="showModalTestCertificate('approve',item.key)"
                                >Xác nhận</el-button
                              >
                            </el-form-item>
                          </b-col>
                        </b-row>
                      </el-collapse-item>
                  </el-collapse>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>

          <b-row class="mt-3 mb-4">
            <b-col md="12">
              <el-form-item class="text-center">
                <el-button
                  v-if="mData.viewMode == 'approve'"
                  @click="fn_go()"
                  >Quay lại</el-button
                >
                <el-button
                  v-if="!mData.isWaitingForVaccineApproval"
                  type="danger"
                  @click="mData.dataDefault.dialogReject = true"
                  :disabled="mData.dataDefault.blockButton"
                  >Hủy mã</el-button
                >
                <el-button
                  v-if="!mData.isWaitingForVaccineApproval"
                  type="primary"
                  @click="mData.dataDefault.dialogApprove = true"
                  :disabled="mData.dataDefault.blockButton"
                  >Xác nhận</el-button
                >
                <el-button
                  v-if="mData.isWaitingForVaccineApproval"
                  type="danger"
                  @click="mData.dataDefault.dialogRejectVaccine = true"
                  :disabled="mData.dataDefault.blockButton"
                  >Hủy mã</el-button
                >
                <el-button
                  v-if="mData.isWaitingForVaccineApproval"
                  type="primary"
                  @click="mData.dataDefault.dialogApproveVaccine = true"
                  :disabled="mData.dataDefault.blockButton"
                  >Xác nhận</el-button
                >
              </el-form-item>
            </b-col>
          </b-row>
        </el-form>
      </div>
    </div>
    <el-dialog
      title="Thông báo"
      :visible.sync="mData.dataDefault.dialogReject"
      width="30%"
      center
    >
      <div class="text-center">
        <p style="word-break: break-word;">Bạn có chắc hủy mã QR này?</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mData.dataDefault.dialogReject = false"
          >Hủy</el-button
        >
        <el-button type="primary" @click="fn_rejectQr()">Xác nhận</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="Thông báo"
      :visible.sync="mData.dataDefault.dialogApprove"
      width="30%"
      center
    >
      <div class="text-center">
        <p style="word-break: break-word;">Bạn có chắc xác nhận mã QR này?</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mData.dataDefault.dialogApprove = false"
          >Hủy</el-button
        >
        <el-button type="primary" @click="fn_approveQr()">Xác nhận</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Thông báo"
      :visible.sync="mData.dataDefault.dialogRejectVaccine"
      width="30%"
      center
    >
      <div class="text-center">
        <p style="word-break: break-word;">Bạn có chắc hủy chứng nhận Vaccine này?</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mData.dataDefault.dialogRejectVaccine = false"
          >Hủy</el-button
        >
        <el-button type="primary" @click="fn_rejectVaccine()">Xác nhận</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="Thông báo"
      :visible.sync="mData.dataDefault.dialogApproveVaccine"
      width="30%"
      center
    >
      <div class="text-center">
        <p style="word-break: break-word;">Bạn có chắc xác nhận chứng nhận Vaccine này?</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mData.dataDefault.dialogApproveVaccine = false"
          >Hủy</el-button
        >
        <el-button type="primary" @click="fn_approveVaccine()">Xác nhận</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Thông báo"
      :visible.sync="mData.dataDefault.dialogRefuseTest"
      width="30%"
      center
    >
      <div class="text-center">
        <p style="word-break: break-word;">Bạn có chắc từ chối chứng chỉ xét nghiệm này?</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mData.dataDefault.dialogRefuseTest = false"
          >Hủy</el-button
        >
        <el-button type="primary" @click="fn_submit('refuse')">Xác nhận</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="Thông báo"
      :visible.sync="mData.dataDefault.dialogApproveTest"
      width="30%"
      center
    >
      <div class="text-center">
        <p style="word-break: break-word;">Bạn có chắc duyệt chứng chỉ xét nghiệm này?</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mData.dataDefault.dialogApproveTest = false"
          >Hủy</el-button
        >
        <el-button type="primary" @click="fn_submit('approve')">Xác nhận</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ForeignerQrApi from "../../../moduleApi/ForeignerQrApi";
import QuocGiaApi from "../../../moduleApi/QuocGiaApi";
import LanguageService from "../../../service/LanguageService";
import KBYTTiepXucApi from "../../../moduleApi/KBYTTiepXucApi";
import KBYTBenhApi from "../../../moduleApi/KBYTBenhApi";
import VaccineApi from "../../../moduleApi/VaccineApi";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from "vue-qrcode-reader";
import ForeignerApi from "../../../moduleApi/ForeignerApi";
import QrCode from "vue-qrcode-component";
import * as moment from 'moment';

export default {
  components: {
    QrcodeStream,
    QrcodeDropZone,
    QrcodeCapture,
    QrCode
  },
  filters: {
    dateFormat: function (value) {
      let format = "DD/MM/YYYY";
      if (!value) return ''
      return moment(value).format(format);
    }
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      activeNames: '',
      imgUrl: ExtensionService.urlImg,
      mData: {
        isWaitingForVaccineApproval: false, 
        viewMode: "detail",
        moduleName: "ListTestCertificate",
        dataDefault: {
          arrTestCertificate: [],
          listQuocGia: [],
          listDauHieu: [
            {
              name: "Ho",
              value: "ho",
            },
            {
              name: "Sốt",
              value: "sot",
            },
            {
              name: "Khó thở",
              value: "kho_tho",
            },
            {
              name: "Viêm phổi",
              value: "viem_phoi",
            },
            {
              name: "Đau họng",
              value: "dau_hong",
            },
            {
              name: "Mệt mỏi",
              value: "met_moi",
            },
          ],
          listKBYTTiepXuc: [],
          listKBYTBenh: [],
          listVaccine: [],
          anh: "",
          anhVaccinations:[],
          anhVaccinationsUrl:[],
          data: null,
          qr: "",
          dataPassport: {
            anh_chan_dung_id: null,
            ho_chieu: {
              loai: "",
              ma_so: "",
              ho_ten: "",
              quoc_tich_id: "",
              ngay_sinh: null,
              so_ho_chieu: "",
              noi_sinh: "",
              gioi_tinh: null,
              cmnd: "",
              ngay_cap: null,
              hieu_luc_den: null,
              noi_cap: "",
            },
          },
          anhSelfie: "",
          anhPassport: "",
          dialogReject: false,
          dialogApprove: false,
          dialogRejectVaccine: false,
          dialogApproveVaccine: false,
          dialogRefuseTest: false,
          dialogApproveTest: false,
          key: "",
          blockButton: true,
          camera: 'auto'
        },
        dataForm: {
          y_te: {
            danh_sach_quoc_gia_da_den: "",
            danh_sach_dau_hieu: "",
            danh_sach_tiep_xuc: "",
            danh_sach_benh: "",
            than_nhiet: "",
          },
          tiem_chung: {
            luot_tiem: [
              {
                thoi_gian_tiem: null,
                dia_diem_tiem: "",
              },
            ],
            vaccine: "",
            gia_tri_den: null,
            so_giay_chung_nhan: "",
            anh_id: "",
            qr: "",
            link: "",
            quoc_gia_id:""
          },
          loai: "",
        },
        validForm: {},
        fileUploadOption: {
          Anh: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
        },
      },
    };
  },
  methods: {
    async initData() {
      try {
        let res = await QuocGiaApi.list();
        this.mData.dataDefault.listQuocGia = res.result;
        let resTX = await KBYTTiepXucApi.list();
        this.mData.dataDefault.listKBYTTiepXuc = resTX.result;
        let resBenh = await KBYTBenhApi.list();
        this.mData.dataDefault.listKBYTBenh = resBenh.result;
        let resVaccine = await VaccineApi.list();
        this.mData.dataDefault.listVaccine = resVaccine.result;
      } catch (error) {}
    },
    async fn_getDataById(id){
      let res = await QuocGiaApi.list();
        this.mData.dataDefault.listQuocGia = res.result;
      let data = await ForeignerQrApi.list({
        filters: "id="+id
      });
      if(data.result && data.result.length >0){
        this.mData.dataDefault.data = data.result[0];
        console.log("this.mData.dataDefault.data",this.mData.dataDefault.data);
        this.mData.dataDefault.arrTestCertificate = this.mData.dataDefault.data.xet_nghiem.reverse();
        // if(this.mData.dataDefault.data.xet_nghiem.length <= 5){
        //   this.mData.dataDefault.arrTestCertificate = this.mData.dataDefault.data.xet_nghiem.reverse();
        // }else{
        //   this.mData.dataDefault.arrTestCertificate = this.mData.dataDefault.data.xet_nghiem.slice(this.mData.dataDefault.data.xet_nghiem.length - 5, this.mData.dataDefault.data.xet_nghiem.length);
        // }
        this.mData.dataDefault.arrTestCertificate.forEach(item => {
          item.key = Math.random().toString(36).substring(2);
          if(item.duoc_duyet == undefined){
            item.duoc_duyet = "";
          }
          let quocGia = this.mData.dataDefault.listQuocGia.find(
            element => {
              return element.id == item.quoc_gia_id;
            }
          );
          if(quocGia){
            item.ten_quoc_gia = quocGia.ten_quoc_gia.vi;
          }
        })
        console.log("this.mData.dataDefault.arrTestCertificate",this.mData.dataDefault.arrTestCertificate);
        if (
          this.mData.dataDefault.data.khai_bao &&
          this.mData.dataDefault.data.khai_bao.y_te &&
          this.mData.dataDefault.data.khai_bao.tiem_chung
        ) {
          if(this.mData.dataDefault.data.khai_bao.tiem_chung.anh_ids){
            this.mData.dataDefault.anhVaccinations = this.mData.dataDefault.data.khai_bao.tiem_chung.anh_ids;
            
            this.mData.dataDefault.anhVaccinations.forEach(e => this.mData.dataDefault.anhVaccinationsUrl.push({
              id: e,
              url : window.MyConfig.hostApi + "file/thumb?id=" + e
            }))
          }
          this.fillData();
        }
        if (this.mData.dataDefault.data.foreigner_id) {
          this.getDataPassport(this.mData.dataDefault.data.foreigner_id);
        }
      }else{
        window.toastr.error("Không tìm thấy thông tin!");
        this.mData.dataDefault.camera = 'auto';
        this.mData.dataDefault.qr = undefined;
      }
    },
    //upload ảnh
    fn_uploadCheckFileSize(file) {
      return MethodService.checkFileSize(file, 3);
    },

    fn_uploadRemoveAnh(file, fileList) {
      this.mData.dataForm.anh = null;
      this.mData.fileUploadOption.Anh.fileList = [];
    },
    async fn_uploadChangeAnh(file, fileList) {
      ExtensionService.upload(file, "foreigner")
        .then((res) => {
          this.mData.dataForm.tiem_chung.anh_id = res.result;
          this.mData.dataDefault.anh =
            window.MyConfig.hostApi + "file/thumb?id=" + res.result;
        })
        .catch((error) => {
          toastr.error("An error occurred!");
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnh(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.Anh.limit} file`
      );
    },
    fn_uploadPreviewAnh(file) {
      this.mData.fileUploadOption.Anh.dialogImageUrl = file.url;
      this.mData.fileUploadOption.Anh.dialogVisible = true;
    },
    async onDecode(decodedString) {
      this.mData.dataDefault.camera = 'off';
      if ((decodedString.substring(0, 3) === "TP-") || (decodedString.substring(0, 3) === "HC1")) {
        this.mData.dataDefault.qr = decodedString;
        await this.getData(decodedString);
      }else{
        window.toastr.error("Không tìm thấy thông tin!");
        this.mData.dataDefault.camera = 'auto';
        this.mData.dataDefault.qr = undefined;
        return;
      }
    },
    changeRadioValue() {
      this.$refs["myForm"].fields
        .find(
          (f) =>
            f.prop == "tiem_chung.qr" ||
            f.prop == "tiem_chung.link" ||
            f.prop == "tiem_chung.anh_id"
        )
        .resetField();
    },
    async fn_rejectQr() {
      this.mData.dataDefault.blockButton = true;
      try{
        await ForeignerQrApi.rejectQR(
          this.mData.dataDefault.data.id,
          {}
        );
      }
      catch (e) {
        this.mData.dataDefault.blockButton = false;
      }
      this.mData.dataDefault.dialogReject = false;
    },
    async fn_approveQr() {
      this.mData.dataDefault.blockButton = true;
      try {
        await ForeignerQrApi.approveQR(
          this.mData.dataDefault.data.id,
          {}
        );
      }
      catch (e) {
        this.mData.dataDefault.blockButton = false;
      }
      this.mData.dataDefault.dialogApprove = false;
    },
    async fn_rejectVaccine() {
      this.mData.dataDefault.blockButton = true;
      try{
        await ForeignerQrApi.rejectVaccine(
          this.mData.dataDefault.data.id,
          {}
        );
      }
      catch (e) {
        this.mData.dataDefault.blockButton = false;
      }
      this.mData.dataDefault.dialogRejectVaccine = false;
    },
    async fn_approveVaccine() {
      this.mData.dataDefault.blockButton = true;
      try {
        await ForeignerQrApi.approveVaccine(
          this.mData.dataDefault.data.id,
          {}
        );
      }
      catch (e) {
        this.mData.dataDefault.blockButton = false;
      }
      this.mData.dataDefault.dialogApproveVaccine = false;
    },

    async getData(qr) {
      let res = await QuocGiaApi.list();
        this.mData.dataDefault.listQuocGia = res.result;
      this.mData.dataDefault.arrTestCertificate = [];
      this.mData.dataDefault.data = {};
      let encodeURI = encodeURIComponent(qr);
      let data = await ForeignerQrApi.list({
        filters: "qr=" + encodeURI  + "|khai_bao.tiem_chung.qr="+ encodeURI + "|xet_nghiem.qr_code=" + encodeURI + "&trang_thai:in:cho_cap_visa,cho_duyet_vaccine",
      });
      if (data.result && data.result.length > 0) {
        this.mData.dataDefault.data = data.result[0];
        console.log("this.mData.dataDefault.data",this.mData.dataDefault.data);
        if(this.mData.dataDefault.data.xet_nghiem && this.mData.dataDefault.data.xet_nghiem.length > 0){
          this.mData.dataDefault.arrTestCertificate = this.mData.dataDefault.data.xet_nghiem.reverse();
        }
        // if(this.mData.dataDefault.data.xet_nghiem.length <= 5){
        //   this.mData.dataDefault.arrTestCertificate = this.mData.dataDefault.data.xet_nghiem.reverse();
        // }else{
        //   this.mData.dataDefault.arrTestCertificate = this.mData.dataDefault.data.xet_nghiem.slice(this.mData.dataDefault.data.xet_nghiem.length - 5, this.mData.dataDefault.data.xet_nghiem.length);
        // }
        this.mData.dataDefault.arrTestCertificate.forEach(item => {
          item.key = Math.random().toString(36).substring(2);
          if(item.duoc_duyet == undefined){
            item.duoc_duyet = "";
          }
          let quocGia = this.mData.dataDefault.listQuocGia.find(
            element => {
              return element.id == item.quoc_gia_id;
            }
          );
          if(quocGia){
            item.ten_quoc_gia = quocGia.ten_quoc_gia.vi;
          }
        })
        console.log("this.mData.dataDefault.arrTestCertificate",this.mData.dataDefault.arrTestCertificate);
        if(this.mData.dataDefault.data.trang_thai == "cho_duyet_vaccine"){
          this.mData.isWaitingForVaccineApproval = true;
        }else{
          this.mData.isWaitingForVaccineApproval = false;
        }
        if (
          this.mData.dataDefault.data.khai_bao &&
          this.mData.dataDefault.data.khai_bao.y_te &&
          this.mData.dataDefault.data.khai_bao.tiem_chung
        ) {
          if(this.mData.dataDefault.data.khai_bao.tiem_chung.anh_ids){
            this.mData.dataDefault.anhVaccinations = this.mData.dataDefault.data.khai_bao.tiem_chung.anh_ids;
            
            this.mData.dataDefault.anhVaccinations.forEach(e => this.mData.dataDefault.anhVaccinationsUrl.push({
              id: e,
              url : window.MyConfig.hostApi + "file/thumb?id=" + e
            }))
          }
          this.fillData();
        }
        if (this.mData.dataDefault.data.foreigner_id) {
          this.getDataPassport(this.mData.dataDefault.data.foreigner_id);
        }
        this.mData.dataDefault.blockButton = false;
      } else {
        window.toastr.error("Không tìm thấy thông tin!");
        this.mData.dataDefault.camera = 'auto';
        this.mData.dataDefault.qr = undefined;
      }
    },
    fillData() {
      for (let key of Object.keys(this.mData.dataForm)) {
        if (typeof this.mData.dataForm[key] == "object") {
          for (let keyC of Object.keys(this.mData.dataForm[key])) {
            this.mData.dataForm[key][
              keyC
            ] = this.mData.dataDefault.data.khai_bao[key][keyC];
            if (
              keyC == "anh_id" &&
              this.mData.dataDefault.data.khai_bao[key][keyC]
            ) {
              this.mData.dataDefault.anh =
                window.MyConfig.hostApi +
                "file/thumb?id=" +
                this.mData.dataForm[key][keyC];
            }
          }
        } else {
          this.mData.dataForm[key] = this.mData.dataDefault.data.khai_bao[key];
        }
      }
      if(this.mData.dataForm.tiem_chung.anh_id && ["cho_duyet_vaccine","cho_cap_visa"].includes(this.mData.dataDefault.data.trang_thai)){
        this.mData.dataForm.loai = 1;
      }else{
        this.mData.dataForm.loai = 2;
      }
      // console.log(this.mData.dataForm);
      // if (this.mData.dataForm.tiem_chung.anh_id) {
      //   this.mData.dataForm.loai = 1;
      // } else if (this.mData.dataForm.tiem_chung.qr) {
      //   this.mData.dataForm.loai = 2;
      // } else if (this.mData.dataForm.tiem_chung.link) {
      //   this.mData.dataForm.loai = 3;
      // }
      if(this.mData.dataForm.y_te.than_nhiet == "0"){
        this.mData.dataForm.y_te.than_nhiet = "";
      }
    },

    async getDataPassport(id) {
      let res = await ForeignerApi.findById(id);
      if (res.result) {
        this.mData.dataDefault.dataPassport = res.result;
        if (res.result.ho_chieu && res.result.ho_chieu.anh_id) {
          this.mData.dataDefault.anhPassport =
            window.MyConfig.hostApi +
            "file/thumb?id=" +
            res.result.ho_chieu.anh_id;
        }
        if (res.result.anh_chan_dung_id) {
          this.mData.dataDefault.anhSelfie =
            window.MyConfig.hostApi +
            "file/thumb?id=" +
            res.result.anh_chan_dung_id;
        }
      }
    },

    async find() {
      this.mData.dataDefault.camera = 'off';
      if (!this.mData.dataDefault.qr) {
        window.toastr.error("Vui lòng nhập mã QR");
        this.mData.dataDefault.camera = 'auto';
        MethodService.stopLadda();
        return;
      }
      if (this.mData.dataDefault.qr.substring(0, 3) !== "TP-") {
        window.toastr.error("Không tìm thấy thông tin!");
        this.mData.dataDefault.camera = 'auto';
        this.mData.dataDefault.qr = undefined;
        MethodService.stopLadda();
        return;
      }
      this.getData(this.mData.dataDefault.qr);
    },
    renderTimes(i) {
      if (i == 0) {
        return "Lần 1";
      } else if (i == 1) {
        return "Lần 2";
      } else if (i == 2) {
        return "Lần 3";
      } else {
        return "Lần " + i + 1 ;
      }
    },
    openCamera() {
      this.mData.dataDefault.camera = 'auto';
    },
    showModalTestCertificate(type,key){
      if(type == "refuse"){
        this.mData.dataDefault.dialogRefuseTest = true;
      }else if(type == "approve"){
        this.mData.dataDefault.dialogApproveTest = true;
      }
      this.mData.key = key;
    },
    async fn_submit(type){
      console.log("this.mData.key",this.mData.key); 
      let data = {};
      data.id = this.mData.dataDefault.data.id;
      if(type == "refuse"){
        this.mData.dataDefault.arrTestCertificate.forEach(item => {
          if(item.key == this.mData.key){
            item.duoc_duyet = false;
          }else if(item.duoc_duyet === true || item.duoc_duyet === false){
            item.duoc_duyet = item.duoc_duyet;
          }else{
            item.duoc_duyet = null;
          }
        });
        data.xet_nghiem = this.mData.dataDefault.arrTestCertificate.reverse();
        console.log("data update",data);
        try {
          await ForeignerQrApi.update(data);
        } catch (error) {
          console.log(error);
          window.toastr.error("Đã có lỗi xảy ra, vui lòng thử lại!");
        }
        if(this.mData.viewMode == 'approve'){
          this.fn_getDataById(this.$router.currentRoute.params.id);
        }else if(this.mData.viewMode == 'detail'){
          this.getData(this.mData.dataDefault.qr);
        }
        this.mData.dataDefault.dialogRefuseTest = false;
      }else if(type == "approve"){
        this.mData.dataDefault.arrTestCertificate.forEach(item => {
          if(item.key == this.mData.key){
            item.duoc_duyet = true;
          }else if(item.duoc_duyet === true || item.duoc_duyet === false){
            item.duoc_duyet = item.duoc_duyet;
          }else{
            item.duoc_duyet = null;
          }
        });
        data.xet_nghiem = this.mData.dataDefault.arrTestCertificate.reverse();
        console.log("data update",data);
        try {
          await ForeignerQrApi.update(data);
          // this.fn_getDataById(this.$router.currentRoute.params.id);
        } catch (error) {
          console.log(error);
          window.toastr.error("Đã có lỗi xảy ra, vui lòng thử lại!");
        }
        if(this.mData.viewMode == 'approve'){
          this.fn_getDataById(this.$router.currentRoute.params.id);
        }else if(this.mData.viewMode == 'detail'){
          this.getData(this.mData.dataDefault.qr);
        }
        this.mData.dataDefault.dialogApproveTest = false;
      }
    },
    fn_go(){
      this.$router.go(-1);
    }
  },
  async created() {
    await this.initData();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-approve"
    ) {
      this.mData.viewMode = "approve";
    }
    if(
      this.$router.currentRoute.name ==
      "Admin-TravelPassReview"
    ){
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      await this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: UTM-Cafeta;
  src: url(/fonts/UTM_Cafeta.ttf);
}
@font-face {
  font-family: MYRIADPRO-REGULAR;
  src: url(/fonts/MYRIADPRO-REGULAR.OTF);
}
p{
  margin-bottom: 0;
}
.box-image{
  max-width: 400px;
}
.camera-qr{
  width: 300px; 
  height: 300px; 
  background: #dddddd; 
  position: relative;
}
.hide {
  ::v-deep.el-upload.el-upload--text {
    display: none;
  }
}
.title-list{
    font-weight: 700;
}

.title{
  color: #17b5ee;
  font-family: MYRIADPRO-REGULAR;
  font-weight: 600;
}
.not-reviewed-yet{
  color: #9e9c07;
}
.refuse{
  color: #f80000;
}
.approved{
  color: #04de0f;
}
::v-deep .detected .el-collapse-item__header{
  background-color: #f4d9d6;
}
::v-deep .not-detected .el-collapse-item__header{
  background-color: #d5f0e0;
}
::v-deep .el-collapse-item__header{
  color: #13171a;
  font-family: MYRIADPRO-REGULAR;
  font-weight: 600;
  font-size: 14px;
}
// ::v-deep .el-form-item__label{
//   color: #0c66ad;
//   font-family: MYRIADPRO-REGULAR;
//   font-weight: 600;
// }
::v-deep img {
  object-fit: contain;
  object-position: center;
}
.main-card-header{
  position: fixed;
  top: 60px;
  width: 100%;
  height: 43px;
  z-index : 3;
  background-color: #cdf3f8;
  border-color: #cdf3f8;
  display: flex;
  align-items: center;
}
.main-card-header span{
  font-family: MYRIADPRO-REGULAR;
  color: #0c66ad;
  font-weight: 600;
}
.main-card-body{
  position: relative;
  top: 43px;
}
::v-deep  .image-resize .el-form-item__content{
  max-width: 600px;
}
.detected{
  color: #f70606;
}
.not-detected{
  color: #00eb5e;
}
@media (max-width: 1366px) {
  ::v-deep .el-dialog.el-dialog--center{
    width: 40% !important;
  }
}
@media (max-width: 1015px) {
  ::v-deep .el-dialog.el-dialog--center{
    width: 60% !important;
  }
}
@media (max-width: 767px) {
  .ml-4{
    margin-left: 0px !important;
  }
  .d-flex{
    display: block !important;
  }
  .d-flex-re{
    display: flex !important;
  }
  .qr-scanner{
    max-width : 350px;
    margin: 0 auto;
  }
  .camera-qr{
    width: 350px; 
    height: 350px; 
    background: #dddddd; 
    position: relative;
  }
}
@media (min-width: 1200px) and (max-width: 1304px) {
  ::v-deep .el-collapse-item__header{
    font-size: 12px;
  }
}
@media (max-width: 670px) {
  ::v-deep .el-dialog.el-dialog--center{
    width: 90% !important;
  }
}
@media (max-width: 448px) {
  ::v-deep .el-dialog.el-dialog--center{
    width: 95% !important;
  }
}
@media (min-width: 576px) and (max-width: 708px) {
  
}
@media (max-width: 390px) {
  .d-flex{
    display: block !important;
  }
  .qr-scanner{
    max-width : 230px;
    margin: 0 auto;
  }
  .camera-qr{
    width: 230px; 
    height: 230px; 
    background: #dddddd; 
    position: relative;
  }
  ::v-deep .el-collapse-item__header{
    font-size: 13px;
  }
}
</style>